/**
 * TestimonialCard
 * ---------------
 * Displays a single testimonial quote with author info,
 * avatar initials, institution, and a 5-star rating.
 *
 * Props: { testimonial } — a testimonial object from data/testimonials.js
 */
import styles from './TestimonialCard.module.css';

const StarIcon = () => (
  <svg viewBox="0 0 16 16" fill="currentColor" className={styles.star} aria-hidden="true">
    <path d="M8 1l1.854 3.756L14 5.528l-3 2.924.708 4.129L8 10.396l-3.708 2.185L5 8.452 2 5.528l4.146-.772z"/>
  </svg>
);

const TestimonialCard = ({ testimonial }) => (
  <article className={styles.card}>
    {/* ── Quote mark ── */}
    <div className={styles.quoteIcon} aria-hidden="true">"</div>

    {/* ── Stars ── */}
    <div className={styles.stars} aria-label={`${testimonial.rating} out of 5 stars`}>
      {Array.from({ length: testimonial.rating }).map((_, i) => (
        <StarIcon key={i} />
      ))}
    </div>

    {/* ── Quote text ── */}
    <blockquote className={styles.quote}>
      {testimonial.quote}
    </blockquote>

    {/* ── Author info ── */}
    <div className={styles.author}>
      <div
        className={styles.avatar}
        style={{ background: `${testimonial.color}20`, color: testimonial.color }}
        aria-hidden="true"
      >
        {testimonial.initials}
      </div>
      <div className={styles.authorInfo}>
        <span className={styles.authorName}>{testimonial.author}</span>
        <span className={styles.authorField}>{testimonial.field}</span>
        <span className={styles.authorInstitution}>{testimonial.institution}</span>
      </div>
    </div>
  </article>
);

export default TestimonialCard;
